import { type PaletteOptions } from "@mui/material";

import { approvedColors, niapColors } from "./niapColors";

// Module augmentation to tell TypeScript about your custom colors

const palette: PaletteOptions = {
  primary: {
    main: "#0b2241",
    contrastText: "#fff",
  },
  secondary: {
    main: "#6c757d",
  },
  success: {
    main: "#198754",
  },
  info: {
    main: "#0dcaf0",
  },
  warning: {
    main: "#f8c95a",
  },
  error: {
    main: "#dc3545",
  },
  text: {
    primary: "#212529",
    secondary: "#717171",
    disabled: "#999",
  },
  sidebar: {
    main: "#12315f",
    light: "#677da5",
    contrastText: "#fff",
  },
  accent: {
    main: "#12315f",
    contrastText: "#fff",
  },
  surface: {
    subtle: "#f9f9f9",
  },
  // Niap Colors
  navy: {
    main: niapColors.navy[500],
    light: niapColors.navy[300],
    dark: niapColors.navy[700],
    contrastText: niapColors.glyph[100],
  },
  gold: {
    main: niapColors.gold[500],
    light: niapColors.gold[300],
    dark: niapColors.gold[700],
    contrastText: niapColors.glyph[100],
  },
  rust: {
    main: niapColors.rust[500],
    light: niapColors.rust[300],
    dark: niapColors.rust[700],
    contrastText: niapColors.glyph[100],
  },
  forest: {
    main: niapColors.forest[500],
    light: niapColors.forest[300],
    dark: niapColors.forest[700],
    contrastText: niapColors.glyph[100],
  },
  ink: {
    main: niapColors.ink[500],
    light: niapColors.ink[300],
    dark: niapColors.ink[700],
    contrastText: niapColors.glyph[100],
  },
  glyph: {
    main: niapColors.glyph[500],
    light: niapColors.glyph[300],
    dark: niapColors.glyph[700],
    contrastText: niapColors.glyph[100],
  },
  // Approved Colors
  coral: {
    main: approvedColors.coral.dark,
    light: approvedColors.coral.light,
    dark: approvedColors.coral.dark,
    contrastText: niapColors.glyph[100],
  },
  tangerine: {
    main: approvedColors.tangerine.dark,
    light: approvedColors.tangerine.light,
    dark: approvedColors.tangerine.dark,
    contrastText: niapColors.glyph[100],
  },
  lime: {
    main: approvedColors.lime.dark,
    light: approvedColors.lime.light,
    dark: approvedColors.lime.dark,
    contrastText: niapColors.glyph[100],
  },
  teal: {
    main: approvedColors.teal.dark,
    light: approvedColors.teal.light,
    dark: approvedColors.teal.dark,
    contrastText: niapColors.glyph[100],
  },
  azure: {
    main: approvedColors.azure.dark,
    light: approvedColors.azure.light,
    dark: approvedColors.azure.dark,
    contrastText: niapColors.glyph[100],
  },
  indigo: {
    main: approvedColors.indigo.dark,
    light: approvedColors.indigo.light,
    dark: approvedColors.indigo.dark,
    contrastText: niapColors.glyph[100],
  },
  violet: {
    main: approvedColors.violet.dark,
    light: approvedColors.violet.light,
    dark: approvedColors.violet.dark,
    contrastText: niapColors.glyph[100],
  },
  slate: {
    main: approvedColors.slate.dark,
    light: approvedColors.slate.light,
    dark: approvedColors.slate.dark,
    contrastText: niapColors.glyph[100],
  },
};

export default palette;
